module.exports = __webpack_public_path__ + "src/assets/individualImages/queenBeeCrownSkin.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/individualImages/queenBeeCrownSkin.png
// module id = ./src/assets/individualImages/queenBeeCrownSkin.png
// module chunks = 0